import InvoiceRedirect from './InvoiceRedirect'

export default InvoiceRedirect
